/**
 * Pearla 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const pearlaPaymentConfig: BrandPaymentConfig = {
  brand: 'pearla',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/pearla/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/pearla/vip_bg.webp',
      memberSubscribeBg: '/images/pearla/member_subscribe_bg.webp',
      vipIcon: '/images/pearla/vip_icon2.png',
      vipDiscountIcon: '/images/pearla/vip_discount.png',
      discountBg: '/images/pearla/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #C8A8FF 0%, #E0CCFF 70%, #F8F5FF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #AB75FB, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#AB75FB',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FAF5FF',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #C8A8FF 0%, #E0CCFF 70%, #F8F5FF 100%)',
      pinkGradient: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%)',
      memberSubscribeBg: '/images/pearla/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
